import { Card, Row, Col, Form } from "react-bootstrap";
import {
  RiErrorWarningLine,
  RiTimeLine,
  RiInformationLine,
  RiInformationFill
} from "react-icons/ri";
import { NOTIFICATION_TYPE } from "../../constants/Constants";

export default function AlertTypes({ types, setTypes }) {

  const checkBoxHandler = (e) => {
    const { name, checked } = e.target;
    setTypes((pre) => pre.map((item) => item.type === name ? { ...item, enabled: checked } : item))
  }

  return (
    <Card className="ap-card alert-types-card">

      {/* HEADER */}
      <div className="section-header">
        <div className="step mb-0">2</div>
        <div>
          <h6>Alert Types</h6>
          <p>Select which alerts you want to receive.</p>
        </div>

        <span className="select-all">Select All</span>
      </div>

      <Row className="g-3 mt-2">

        <Col lg={4} md={6}>
          <div className="alert-box">

            {/* TITLE */}
            <div className="alert-title">
              <div className={`icon px-2 red`}>
                <RiErrorWarningLine color="white" />
              </div>
              <div>
                <h6>Critical Alerts</h6>
                <p>Important events that require immediate attention.</p>
              </div>
            </div>

            {/* LIST */}
            <div className="alert-list">
              <div className="alert-item" > <Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.DRIVER_ENTERED} checked={types.find((item) => item.type === NOTIFICATION_TYPE.DRIVER_ENTERED)?.enabled || false} /> <span>Driver Entered Lot</span> </div>
              <div className="alert-item" > <Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.DRIVER_LEFT} checked={types.find((item) => item.type === NOTIFICATION_TYPE.DRIVER_LEFT)?.enabled || false} /> <span>Driver Left Lot</span> </div>
              <div className="alert-item" > <Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.PAYMENT_FAILED} checked={types.find((item) => item.type === NOTIFICATION_TYPE.PAYMENT_FAILED)?.enabled || false} /> <span>Payment Failed</span></div>
            </div>
          </div>
        </Col>

        <Col lg={4} md={6}>
          <div className="alert-box">
            {/* TITLE */}
            <div className="alert-title">
              <div className={`icon px-2 orange`}>
                <RiTimeLine />
              </div>
              <div>
                <h6>Operational Alerts</h6>
                <p>Important operational updates about your yard.</p>
              </div>
            </div>

            {/* LIST */}
            <div className="alert-list">
              <div className="alert-item"><Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.EXPIRATION_REMINDER} checked={types.find((item) => item.type === NOTIFICATION_TYPE.EXPIRATION_REMINDER)?.enabled || false} /> <span>Booking Expiring Soon</span></div>
              <div className="alert-item"  ><Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.SPOT_FULL} checked={types.find((item) => item.type === NOTIFICATION_TYPE.SPOT_FULL)?.enabled || false} /> <span>Spot Almost Full</span></div>
              <div className="alert-item"  ><Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.RESERVATION_STARTED} checked={types.find((item) => item.type === NOTIFICATION_TYPE.RESERVATION_STARTED)?.enabled || false} /> <span>Reservation Started</span></div>
              <div className="alert-item"  ><Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.RESERVATION_ENDED} checked={types.find((item) => item.type === NOTIFICATION_TYPE.RESERVATION_ENDED)?.enabled || false} /> <span>Reservation Ended</span></div>
            </div>
          </div>
        </Col>

        <Col lg={4} md={6}>
          <div className="alert-box">

            {/* TITLE */}
            <div className="alert-title">
              <div className={`icon px-2 blue`}>
                <RiInformationLine />
              </div>
              <div>
                <h6>Info Alerts</h6>
                <p>General information and system updates.</p>
              </div>
            </div>

            {/* LIST */}
            <div className="alert-list">
              <div className="alert-item"  ><Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.BOOKING_CREATED} checked={types.find((item) => item.type === NOTIFICATION_TYPE.BOOKING_CREATED)?.enabled || false} /> <span>New Booking Created</span> </div>
              <div className="alert-item"  > <Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.PAYMENT_SUCCESS} checked={types.find((item) => item.type === NOTIFICATION_TYPE.PAYMENT_SUCCESS)?.enabled || false} /> <span>Payment Received</span> </div>
              <div className="alert-item"  > <Form.Check type="checkbox" onChange={checkBoxHandler} name={NOTIFICATION_TYPE.SYSTEM_NOTIFICATION} checked={types.find((item) => item.type === NOTIFICATION_TYPE.SYSTEM_NOTIFICATION)?.enabled || false} /> <span>System Notifications</span> </div>
            </div>
          </div>
        </Col>
      </Row >

    </Card >
  );
}